import { Component, OnInit, OnDestroy } from '@angular/core';
import { _UsersService } from '../../services/users.service';
import { PermissionActions } from '../../app.actions';
import { IAppState } from '../../interfaces/appstate.interface'
import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

declare var $:any;

@Component({
  selector: 'site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.css']
})
export class SiteComponent implements OnInit, OnDestroy {

  private subscription: any;

  constructor(private users: _UsersService, private ngRedux: NgRedux<IAppState>, private actions: PermissionActions) {
    this.updateUserRoles();
  }
  updateUserRoles() {
    this.subscription = Observable.forkJoin([
      this.users.getUserRoles(),
      this.users.getCurrentUser(),
      // this.users.getUserRules()
    ]).subscribe((res) => {
      this.ngRedux.dispatch(this.actions.getUserRoles(res[0]));
      this.ngRedux.dispatch(this.actions.getUserSettings(res[1]));
      // this.ngRedux.dispatch(this.actions.getUserRules(res[2]));
    });
  }
  ngOnInit() {

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/components/site/site.component.ts